/*
 * Application Insights JavaScript SDK - Common, 2.8.0
 * Copyright (c) Microsoft and contributors. All rights reserved.
 */


import { createEnumStyle } from "@microsoft/applicationinsights-core-js";
export var StorageType = createEnumStyle({
    LocalStorage: 0 /* LocalStorage */,
    SessionStorage: 1 /* SessionStorage */
});
export var DistributedTracingModes = createEnumStyle({
    AI: 0 /* AI */,
    AI_AND_W3C: 1 /* AI_AND_W3C */,
    W3C: 2 /* W3C */
});
//# sourceMappingURL=Enums.js.map